import { Icons } from '../icons';
import { ControlButton } from './ControlButton';
import { FC } from 'react';

type Props = {
  numPages: number | null;
  pageNumber: number;
  scale: number;
  handlePreviousClick: () => void;
  handleNextClick: () => void;
  downloadPdf: () => void;
  zoomIn: () => void;
  zoomOut: () => void;
  toggleShowPreview: () => void;
  isPreviewOpen: boolean;
};

export const ControlPanel: FC<Props> = ({
  numPages,
  pageNumber,
  scale,
  handleNextClick,
  handlePreviousClick,
  downloadPdf,
  zoomIn,
  zoomOut,
  toggleShowPreview,
  isPreviewOpen,
}) => {
  return (
    <div className="flex items-center justify-between p-4 rounded-full w-110 bg-base-black/[0.7] mt-2 gap-3 h-13">
      <ControlButton
        disabled={pageNumber <= 1 || numPages === 1}
        onClick={handlePreviousClick}
        icon={Icons.ChevronLeft}
        tooltipText="Previous page"
      />

      <div className="h-full w-px bg-base-white/[0.1]" />

      <span className="text-sm font-medium text-base-white whitespace-nowrap">
        Page {pageNumber} / {numPages || '1'}
      </span>

      <div className="h-full w-px bg-base-white/[0.1]" />

      <div className="flex items-center justify-center gap-2 min-w-28">
        <ControlButton
          onClick={zoomOut}
          icon={Icons.MinusRoundSquare}
          tooltipText="Zoom out"
        />

        <span className="text-sm font-medium text-base-white">
          {Math.round(scale * 100)}%
        </span>

        <ControlButton
          onClick={zoomIn}
          icon={Icons.PlusRoundSquare}
          tooltipText="Zoom in"
        />
      </div>

      <div className="h-full w-px bg-base-white/[0.1]" />

      <ControlButton
        onClick={downloadPdf}
        icon={Icons.Download02}
        tooltipText="Download"
      />

      <div className="h-full w-px bg-base-white/[0.1]" />

      <ControlButton
        onClick={toggleShowPreview}
        icon={isPreviewOpen ? Icons.Minimize03 : Icons.Expand06}
        tooltipText={isPreviewOpen ? 'Close preview' : 'Preview'}
      />

      <div className="h-full w-px bg-base-white/[0.1]" />

      <ControlButton
        disabled={pageNumber >= (numPages || 1) || numPages === 1}
        onClick={handleNextClick}
        icon={Icons.ChevronRight}
        tooltipText="Next page"
      />
    </div>
  );
};
